(() => {
  if (customElements.get('npx-navigation-rail')) return;

  class NpxNavigationRail extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
      this.header = this.section?.querySelector('.xo-header__sticky');
      this.toggle = this.section?.querySelector('[data-npx-navigation-toggle]');
      if (!this.header || !this.toggle) return;
      this.connected = true;
      this.media = window.matchMedia('(min-width: 1200px)');
      this.defaultState = this.dataset.defaultState === 'collapsed' ? 'collapsed' : 'expanded';
      let state = this.defaultState;
      try {
        const saved = localStorage.getItem('npx-navigation-state');
        if (saved === 'expanded' || saved === 'collapsed') state = saved;
      } catch (_) {}
      this.expanded = state === 'expanded';
      this.frame = 0;
      this.schedule = () => {
        if (this.frame || !this.media.matches || !this.expanded) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          const top = Math.max(0, Math.min(window.innerHeight, this.header.getBoundingClientRect().bottom));
          this.style.setProperty('--npx-navigation-top', `${Math.round(top)}px`);
        });
      };
      this.sync = () => {
        const desktop = this.media.matches;
        const visible = desktop && this.expanded;
        if (!visible && this.contains(document.activeElement)) {
          const target = desktop ? this.toggle : this.section.querySelector('.npx-category-header__trigger button, .npx-category-header__trigger [role="button"]');
          target?.focus();
        }
        document.documentElement.dataset.npxNavigationState = this.expanded ? 'expanded' : 'collapsed';
        this.hidden = !visible;
        this.inert = !visible;
        this.toggle.hidden = !desktop;
        this.toggle.setAttribute('aria-expanded', String(this.expanded));
        const label = this.expanded ? this.toggle.dataset.labelClose : this.toggle.dataset.labelOpen;
        if (label) this.toggle.setAttribute('aria-label', label);
        this.schedule();
      };
      this.setExpanded = (expanded, save = false) => {
        this.expanded = expanded;
        if (save) {
          try {
            localStorage.setItem('npx-navigation-state', expanded ? 'expanded' : 'collapsed');
          } catch (_) {}
        }
        this.sync();
      };
      this.onToggle = () => this.setExpanded(!this.expanded, true);
      this.onEscape = (event) => {
        if (event.key !== 'Escape' || !this.media.matches || !this.expanded) return;
        event.preventDefault();
        event.stopPropagation();
        this.setExpanded(false, true);
        this.toggle.focus();
      };
      this.onStorage = (event) => {
        if (event.key !== 'npx-navigation-state' && event.key !== null) return;
        const next = event.newValue === 'expanded' || event.newValue === 'collapsed' ? event.newValue : this.defaultState;
        this.setExpanded(next === 'expanded');
      };
      this.toggle.addEventListener('click', this.onToggle);
      this.toggle.addEventListener('keydown', this.onEscape);
      this.addEventListener('keydown', this.onEscape);
      this.media.addEventListener('change', this.sync);
      window.addEventListener('storage', this.onStorage);
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.header);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      this.sticky = this.header.closest('xo-sticky');
      this.sticky?.addEventListener('transitionend', this.schedule);
      document.querySelectorAll('.shopify-section-group-header-group').forEach((section) => this.resizeObserver.observe(section));
      this.sync();
    }

    disconnectedCallback() {
      if (!this.connected) return;
      this.connected = false;
      this.toggle.removeEventListener('click', this.onToggle);
      this.toggle.removeEventListener('keydown', this.onEscape);
      this.removeEventListener('keydown', this.onEscape);
      this.media.removeEventListener('change', this.sync);
      window.removeEventListener('storage', this.onStorage);
      this.resizeObserver.disconnect();
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.sticky?.removeEventListener('transitionend', this.schedule);
      cancelAnimationFrame(this.frame);
    }
  }

  customElements.define('npx-navigation-rail', NpxNavigationRail);
})();
